/**
 * トラッキングツールの利用可否を判定する
 */
// SSR中は使用不可
export const canUseTrackingTool = () => typeof window !== 'undefined'
